module.exports = __webpack_public_path__ + "img/ic-home-tixian.7e5e.ccd99b9e.png";